/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { GET_APPLICATION_FEE_DURATION } from "../pages/NewEpccApplication/graphql";
import { toast } from "react-hot-toast"

const MODULE_NAME = "ApplicationFeeDurationService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export class ApplicationFeeDurationService {
    private static instance: ApplicationFeeDurationService;
    private vapp: VApplication;
    // private termsURL: string;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
        // this.termsURL = props?.termsURL
    }
    public static getInstance(props: any = {}): ApplicationFeeDurationService {
        if (!ApplicationFeeDurationService.instance) {
            ApplicationFeeDurationService.instance = new ApplicationFeeDurationService(props);
        }
        return ApplicationFeeDurationService.instance;
    }


    async getApplicationFeeDuration(isCitizen: string, isAdult: string, processType: string) {
        
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        if(!client){
            console.log('graphql-gateway is not available !!!!!!');
        }

        console.log('ApplicationFeeDurationService()::getApplicationFeeDuration()-> entered here..');

        try {
            if (client) {
                const res = await client.query({
                    query: GET_APPLICATION_FEE_DURATION,
                    variables: {
                        isCitizen,
                        isAdult,
                        processType
                    },

                    fetchPolicy: "network-only",
                });
                log.success(MODULE_NAME, "getApplication fee duration: ", res?.data);
                if (res) {
                    console.log(res?.data?.getProcessFeeDuration)
                    return res?.data?.getProcessFeeDuration;
                }
            }
        } catch (err: any) {
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }
}
